import { render } from "./DelegationSidePanel.vue?vue&type=template&id=6f2e8722"
import script from "./DelegationSidePanel.vue?vue&type=script&lang=js"
export * from "./DelegationSidePanel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__